'use strict';

/**
 * @ngdoc function
 * @name gfcmsApp.controller:UserDetailsCtrl
 * @description
 * # UserDetailsCtrl
 * Controller of the gfcmsApp
 */
angular.module('gfcmsApp')
  .controller('UserDetailsCtrl', function ($scope, $http, $location, $routeParams,
    userService, FlashService, cfpLoadingBar) {

      var userVm = this;

      userVm.id = $routeParams.userId;
      userVm.activityList = [];
      userVm.activitiesExist = false;
      userVm.GetUser = GetUser;
      activate();

      function activate() {
        userVm.GetUser(userVm.id);
        getUserActivities(userVm.id);
      }

      function GetUser(id) {
        cfpLoadingBar.start();
        userService.GetById(id).
        then(function(response) {
            userVm.user = response;
            userVm.firstName = userVm.user.firstName;
        }, function (error) {
          FlashService.Error('Network Error. Try reloading the page', false);
        }).finally(function () {
          cfpLoadingBar.complete();
        });
      }
      function getUserActivities(id) {
        cfpLoadingBar.start();
        userService.getUserActivityLogs(id).
        then(function(response) {
            userVm.activityList = response;
            userVm.activitiesExist = !!userVm.activityList.length;
        })
        .catch(function (error) {
          FlashService.Error('Network Error. Try reloading the page', false);
        })
        .finally(function () {
          cfpLoadingBar.complete();
        });
      }

      return userVm;
  });
